
import React from 'react';
import { GuestLecture2026 } from '../views';

const KindergartenPage = () => {
  return <GuestLecture2026/>;
};

export default KindergartenPage;
